var React = require('react');

function IcSsoMicrosoft (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"white","key":0}),React.createElement("g",{"clipPath":"url(#clip0_7_7405)","key":1},[React.createElement("path",{"d":"M4 4H9.71429V9.71429H4V4Z","fill":"#F35325","key":0}),React.createElement("path",{"d":"M10.2856 4H15.9999V9.71429H10.2856V4Z","fill":"#81BC06","key":1}),React.createElement("path",{"d":"M4 10.2856H9.71429V15.9999H4V10.2856Z","fill":"#05A6F0","key":2}),React.createElement("path",{"d":"M10.2856 10.2856H15.9999V15.9999H10.2856V10.2856Z","fill":"#FFBA08","key":3})]),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_7_7405"},React.createElement("rect",{"width":"12","height":"12","fill":"white","transform":"translate(4 4)"})))]);
}

IcSsoMicrosoft.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcSsoMicrosoft;

IcSsoMicrosoft.default = IcSsoMicrosoft;
